import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';

import { useCoaches } from '@/data/coach';

import CoachList from './components/list/CoachList';

const ListPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Coaches
        </CardTitle>
        <CardDescription>
          List of all coaches who have applied to work at at least one of your
          locations.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CoachList />
      </CardContent>
    </Card>
  );
};

const ListPageLoader = () => {
  const coaches = useCoaches();

  if (coaches.isLoading && !coaches.data) {
    return <LoadingPage />;
  }

  return <ListPage />;
};

export default ListPageLoader;
